import styled from "styled-components";

/* What the AI does with what's asked, on top of the form's card */
export const Description = styled.p`
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--color-neutral-150);
`;
